import { EntityServices } from "@sdk/utils/entity.service";
import type { PaginatedOptions, PaginatedResults } from "@sdk/utils/paginated-results";
import type { iSupplierBillPaymentReceipt } from "./supplier-bill-payment-receipt-model";
import { postAccountingListReport } from "@sdk/accounting/accounting-list-report.service";
import type { SupplierBillPaymentReceiptListRow } from "@sdk/accounting/accounting-list-report.models";

export class SupplierBillPaymentReceiptsServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
    this.supplierBillPaymentReceipts.configure(config);
  }

  constructor(protected config: { basePath: string; token: string }) {
    this.supplierBillPaymentReceipts = Object.assign(
      new EntityServices<iSupplierBillPaymentReceipt>(
        config,
        "supplier-bill-payment-receipts",
        {}
      ),
      {
        report: (req: {
          query: Record<string, unknown>;
          options?: PaginatedOptions;
        }) =>
          postAccountingListReport<SupplierBillPaymentReceiptListRow>(
            config,
            "supplier-bill-payment-receipts",
            req
          ),
      }
    );
    this.supplierBillPaymentReceipts.configure(config);
  }

  supplierBillPaymentReceipts!: EntityServices<iSupplierBillPaymentReceipt> & {
    report: (req: {
      query: Record<string, unknown>;
      options?: PaginatedOptions;
    }) => Promise<PaginatedResults<SupplierBillPaymentReceiptListRow>>;
  };
}
